export default {
	ACTION: "ACTION",
	FIELD: "FIELD",
	FORM: "FORM",
	GRID: "GRID"
};
